import App from "./App";
import DialogProvider from "./libs/dialog/DialogProvider";
import SnackbarProvider from "./libs/dialog/SnackbarProvider";
import PathProvider from "./libs/path/PathProvider";
import "./scss/index.scss"

import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import FManApi from "./fmanlibs/FManApi";
import { LoginContextProvider } from "./libs/login/useLogin";
import Dirs from "./fmanlibs/Dirs";
import Files from "./fmanlibs/Files";
import { IUser } from "./libs/login/JWTApi";

(() => {
    const root = ReactDOM.createRoot(document.getElementById("root")!)
    FManApi.i.init()

    const onAuth = async (user:IUser) => {
        await Dirs.i.expire().get();        
        const home = (await Dirs.i.root).getChildByName("Home")
        if (home) Files.i.expire(home._id).get(home._id)
    }
    root.render(
    <PathProvider><SnackbarProvider><DialogProvider><LoginContextProvider api={FManApi.i} onAuth={onAuth}>
        <App/>
    </LoginContextProvider></DialogProvider></SnackbarProvider></PathProvider>
    )

    serviceWorkerRegistration.register()

})()